import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { LayoutPreview } from '../../../LayoutPreview';
import { SidebarItem } from '../../../LayoutPreview/layoutPreviewTypes';
import BaseTypography from '../../../Text/BaseTypography';
import { IconNameToComponent, IconType } from '../../../Icons';
import {
  FILES_PAGE,
  FORMS_PAGE,
  KNOWLEDGE_BASE_PAGE,
  MESSAGES_PAGE,
  PAYMENTS_PAGE,
} from '../../../../constants';
import { GraySmall } from '../../../../theme/colors';

interface ExtensionModuleContentPreviewProps {
  embedContent: string;
  extensionName: string;
  extensionIcon: IconType;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: theme.spacing(2),
      paddingBottom: theme.spacing(12.5),
    },
    clientPreviewText: {
      letterSpacing: '2px',
      color: GraySmall,
      marginBottom: theme.spacing(1.5),
    },
    layoutContainer: {
      width: 800,
      height: 500,
    },
    layoutContent: {
      width: '-webkit-fill-available',
    },
    sidebar: {
      minWidth: 111,
      width: 111,
      borderBottomLeftRadius: theme.shape.borderRadius,
    },
    layoutBody: {
      height: '100%',
      overflowX: 'auto',
      maxHeight: '400px',
      maxWidth: '650px',
    },
    iFrameContainer: {
      height: 'calc(100% - 58px)',
    },
  }),
);

const sidebarDefaultItems = {
  MESSAGES: {
    title: MESSAGES_PAGE.label,
    icon: MESSAGES_PAGE.icon,
  },
  FILES: {
    title: FILES_PAGE.label,
    icon: FILES_PAGE.icon,
  },
  FORMS: {
    title: FORMS_PAGE.label,
    icon: FORMS_PAGE.icon,
  },
  BILLING: {
    title: PAYMENTS_PAGE.label,
    icon: PAYMENTS_PAGE.icon,
  },
  KNOWLEDGE_BASE: {
    title: KNOWLEDGE_BASE_PAGE.label,
    icon: KNOWLEDGE_BASE_PAGE.icon,
  },
};
export const ExtensionModuleContentPreview: React.FC<ExtensionModuleContentPreviewProps> = ({
  embedContent,
  extensionName,
  extensionIcon,
}) => {
  const classes = useStyles();

  const ExtensionIconComponent = IconNameToComponent[extensionIcon];

  const sidebarItems: Array<SidebarItem> = React.useMemo(
    () => [
      sidebarDefaultItems.MESSAGES,
      sidebarDefaultItems.FILES,
      sidebarDefaultItems.FORMS,
      sidebarDefaultItems.BILLING,
      sidebarDefaultItems.KNOWLEDGE_BASE,
      {
        title: extensionName,
        icon: ExtensionIconComponent,
        active: true,
      },
    ],
    [extensionIcon, extensionName],
  );
  return (
    <div className={classes.root}>
      <BaseTypography
        className={classes.clientPreviewText}
        fontType="15Regular"
      >
        Client preview
      </BaseTypography>
      <LayoutPreview
        classes={{
          layoutContainer: classes.layoutContainer,
          layoutContent: classes.layoutContent,
          layoutBody: classes.layoutBody,
          sidebar: classes.sidebar,
        }}
        items={sidebarItems}
      >
        <div
          className={classes.iFrameContainer}
          dangerouslySetInnerHTML={{
            __html: embedContent,
          }}
        />
      </LayoutPreview>
    </div>
  );
};
